<img class="w-100" [src]="slide.image" style="max-height: 580px;" alt="Image">
<div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
    <div class="p-3" style="max-width: 900px;">
        <h5 class="text-white text-uppercase mb-3 animated slideInDown">{{slide.type}}</h5>
        <h1 class="display-1 text-white mb-md-4 animated zoomIn">{{slide.title}}</h1>
        <p>{{slide.description}}</p>
       <a [routerLink]="slide.url" class="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">Read more</a>
    </div>
</div>